var _rect, _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanexpired({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 66,
    viewBox: "0 0 73 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    y: 6,
    width: 60,
    height: 60,
    rx: 14,
    fill: "url(#paint0_linear_71_6182)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 13,
    r: 13,
    fill: "#E84141"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.4931 16H55.506C55.3628 15.9998 55.2212 15.9693 55.0908 15.9105C54.9604 15.8516 54.8441 15.7659 54.7497 15.659C54.6553 15.552 54.585 15.4264 54.5434 15.2903C54.5018 15.1543 54.4899 15.011 54.5086 14.87C54.6798 13.61 55.2037 12.8 55.9896 12.57C56.0702 11.18 56.6042 7 59.9996 7C63.3949 7 63.9289 11.18 64.0095 12.57C64.7853 12.8 65.3193 13.61 65.4906 14.87C65.5309 15.16 65.4402 15.45 65.2488 15.66C65.0574 15.87 64.7853 16 64.4931 16ZM59.9996 19C61.1078 19 62.0146 18.1 62.0146 17H57.9845C57.9845 18.1 58.8913 19 59.9996 19Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 18C20.0585 18 12 26.0585 12 36C12 45.9415 20.0585 54 30 54C39.9415 54 48 45.9415 48 36C48 26.0585 39.9415 18 30 18ZM24.4615 27.6923C24.0943 27.6923 23.7421 27.8382 23.4825 28.0979C23.2228 28.3575 23.0769 28.7097 23.0769 29.0769C23.0769 29.4441 23.2228 29.7963 23.4825 30.056C23.7421 30.3157 24.0943 30.4615 24.4615 30.4615H27.2308C29.04 30.4615 30.5778 31.6172 31.1483 33.2308H24.4615C24.0943 33.2308 23.7421 33.3766 23.4825 33.6363C23.2228 33.896 23.0769 34.2482 23.0769 34.6154C23.0769 34.9826 23.2228 35.3348 23.4825 35.5945C23.7421 35.8541 24.0943 36 24.4615 36H31.1483C30.8619 36.8101 30.3314 37.5114 29.6297 38.0073C28.9281 38.5033 28.09 38.7695 27.2308 38.7692H24.4615C24.1879 38.7695 23.9204 38.8508 23.6929 39.003C23.4655 39.1551 23.2882 39.3713 23.1835 39.6241C23.0788 39.877 23.0514 40.1552 23.1047 40.4236C23.158 40.6921 23.2897 40.9387 23.4831 41.1323L29.0215 46.6708C29.1483 46.8068 29.3012 46.9159 29.471 46.9916C29.6409 47.0673 29.8242 47.108 30.0101 47.1112C30.196 47.1145 30.3807 47.0803 30.5531 47.0107C30.7255 46.941 30.8821 46.8374 31.0136 46.7059C31.1451 46.5744 31.2487 46.4178 31.3184 46.2454C31.388 46.073 31.4222 45.8883 31.4189 45.7024C31.4157 45.5165 31.375 45.3332 31.2993 45.1633C31.2236 44.9935 31.1145 44.8406 30.9785 44.7138L27.7846 41.5163C29.2808 41.3965 30.6975 40.7938 31.8213 39.7988C32.9452 38.8039 33.7152 37.4706 34.0154 36H35.5385C35.9057 36 36.2579 35.8541 36.5175 35.5945C36.7772 35.3348 36.9231 34.9826 36.9231 34.6154C36.9231 34.2482 36.7772 33.896 36.5175 33.6363C36.2579 33.3766 35.9057 33.2308 35.5385 33.2308H34.0154C33.813 32.2259 33.3871 31.2794 32.7692 30.4615H35.5385C35.9057 30.4615 36.2579 30.3157 36.5175 30.056C36.7772 29.7963 36.9231 29.4441 36.9231 29.0769C36.9231 28.7097 36.7772 28.3575 36.5175 28.0979C36.2579 27.8382 35.9057 27.6923 35.5385 27.6923H24.4615Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_6182",
    x1: 30,
    y1: 6,
    x2: 30,
    y2: 66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanexpired);
export default __webpack_public_path__ + "static/media/planexpired.1c7ed4cffd92c5f2135b014a457de8ce.svg";
export { ForwardRef as ReactComponent };